export default "__VITE_ASSET__BWw$1$p$__"